export enum ItemType {
    Menu,
    Submenu,
    Category,
    Item,
}
